/**
 * Re-exported from @hyperframes/engine with ProducerConfig alias.
 * @see engine/src/config.ts for implementation.
 */
export {
  type EngineConfig,
  type EngineConfig as ProducerConfig,
  DEFAULT_CONFIG,
  resolveConfig,
} from "@hyperframes/engine";
